<script setup>
const props = defineProps({
  state: String,
})
</script>

<template>
<div class="flex flex-row items-center justify-start gap-2 overflow-hidden text-ellipsis whitespace-nowrap">
  <div class="ring-opacity-25 rounded-full w-[10px] h-[10px] shrink-0"
        :class="[state === 'New' ? 'bg-[#9E9E9E]' : '',
      state === 'Assigning' ? 'bg-[#EFECDC]' : '',
      state === 'Assigned' ? 'bg-[#FFEB01]' : '',
      state === 'Delivering' ? 'bg-[#FF9800]' : '',
      state === 'Delivered' ? 'bg-[#2196F3]' : '',
      state === 'Canceled' ? 'bg-[#F44336]' : '',
      state === 'Paid' ? 'bg-[#4CAF50]' : '']">
  </div>
  <span class="truncate">{{ state ? state : '&nbsp' }}</span>
</div>
</template>

<style scoped lang="scss">

</style>